<template>
    <div class="Details">
    <section>
        
        <h3 class="title is-3">
                Predict Preview
        </h3>
        
        
        <form v-on:submit.prevent="invoke()">
            <b-field message="Type your text here to preview the model's predictions online">
                    <b-input maxlength="5000"  expanded
                        rows="7"
                        required
                        type="textarea" v-model="text" 
                        placeholder="Type your text here">
                    </b-input>
                </b-field>
                
                <b-field>
            <b-button
                expanded
                tag="button"
                type="is-info"
                native-type="submit"
                value="Compute">
                Run predict
            </b-button>
        </b-field>

            <br>
            
            <b-notification :closable="false" v-if="isLoading">
                {{ invokingText }}&nbsp;
                <b-loading :is-full-page="false" v-model="isLoading" :can-cancel="false">
                </b-loading>
                </b-notification>
                
                <div v-if="result && !isLoading">
                    <b-field>
                        <span v-if="result.length == 0">
                            <b-tag type="is-dark">No prediction</b-tag>
                        </span>
                    <span v-else-if="project.type == 'extraction'">
                    
                    <div v-html="highlight(result)"></div>
                    &nbsp;
                    </span>
                <span v-else-if="project.type == 'classification'">
                    <b-taglist>
                        <b-tag :type=" item.score > 0.5 ? `is-dark` : `is-white`" size="is-medium" v-for="(item, index) in result">
                                {{  item.label }} ({{ parseFloat(item.score).toFixed(2) }})
                        </b-tag>
                    </b-taglist>
                    &nbsp;
                </span>
                    </b-field>
                    <b-button 
                        v-if="result.length > 0"
                        class="is-pulled-right"
                        size="is-small"
                        @click="insertAsRecord()">
                        <i class="fa fa-plus"></i>&nbsp;
                        Add as training record
                    </b-button>
                    <b-collapse 
                        :open="false" 
                        position="is-bottom" 
                        aria-id="contentIdForA11y4">
                        <template #trigger="props">
                            <a
                                aria-controls="contentIdForA11y4"
                                :aria-expanded="props.open">
                                {{ !props.open ? 'Show JSON response' : 'Hide JSON response' }}
                            </a>
                        </template>
                        <p>
                            
                        <b-notification style="overflow-wrap: break-word; color: #f1f1f1; background: #222;" :closable="false">
                        &nbsp;{{ result | pretty }}
                        </b-notification>
                        </p>
                    </b-collapse>
                </div>
            

        </form>
        
    </section>

    </div>
    
</template>
<script>
import Papa from 'papaparse';
import { mapState } from 'vuex';
import TextAnnotation from 'ner-text-annotation';

export default {
     props: ["apiKey", "models", "project", "currentUser", "modelId"],
     name: "Uploads",
     data: function() {
    return {
        all_users_api_key: 'Z0CDIgI42M5hggX0bpBB61UZswN4NiHNaqqsFIWd',
        invokingText: 'Running inference... Please wait, this may take a few seconds for the first time.',
        result: null,
        text: '',
        isLoading: false
      }
    },
    computed: {
        projectModels(){
            return this.$store.state.projectModels
        },
        prediction_results(){
            return this.$store.getters.getPredictionsResult
        },
    },
    components: {
        TextAnnotation
      
    },
    filters: {
            pretty: function(value) {
                console.log(value)
                return JSON.stringify(value, null, 2);
            }
        },
     methods: {
        insertAsRecord(){
            let record = {
                text: this.text,
                labels: this.project.type == 'classification' ? this.result.filter( i => i.score > 0) : [],
                tags: this.project.type == 'extraction' ? this.result.filter( i => i.score > 0) : []
            }

            console.log(record)

            this.$store.dispatch(
                "addRecord",
                    {   text: record.text, 
                        labels: record.labels, 
                        tags: record.tags,
                        projectId: this.project.id,
                        datasetId: this.project.datasetId
                    }
            )
            this.$buefy.snackbar.open({
                message: 'Record added!',
                type: "is-white",
                position: 'is-bottom-left',
                queue: false,
                actionText: "",
            })
        },
        async invoke() {
          this.isLoading = true
          const refresh = false
          const payload = {
            userId: this.currentUser.id, 
            projectId: this.project.id, 
            modelId: this.modelId,
            text: this.text,
            refresh: refresh,
            type: this.project.type,
            api_key: this.apiKey
          }
          
          // tries to run inference
          for (let i = 1; i < 3; i++) {
            const result = await this.$store.dispatch("runInference", payload);
            if (result && Object.hasOwn(result, 'predictions')) {
                this.result = result.predictions
                this.isLoading = false
                break
            } else {
                // retry
                this.invokingText = `Retrying inference (${i})... Please wait, this may take a few seconds for the first time.`
                this.isLoading = true
                // wait 5 seconds
                await new Promise(r => setTimeout(r, 50));
            }
          }
          if (this.isLoading) {
            this.isLoading = false
            this.$buefy.snackbar.open({
                message: 'Inference failed!',
                type: "is-danger",
                position: 'is-bottom-left',
                queue: false,
                actionText: "",
            })
          }
        },
        createRow(){
            this.$store.dispatch('createRow', this.row)
        },
        onlyUnique(value, index, self) {
            return self.indexOf(value) === index;
        },
        highlight(result) {
          
          if (!result || result == 'no prediction');
          
          if(this.project.type != 'extraction') {
            return result;
          }
          
          let highlight = []
          let highlight_text = ''
          result.forEach(async (r) => {
            let span = this.text.substring(r.start, r.end)
            highlight_text = `<span style="margin-bottom: 5px" data-entity="${r.label.toLowerCase()}">${span}&nbsp;<span class='entities-type'><b>${r.label}</b></span></span>`;
            
            highlight.push(highlight_text)
          });
          
          return highlight.join(' ')
        },
     },
     mounted() {
        this.getInputExample()
     }
   };
</script>

<style lang="scss" scoped>
.boards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;

  .board {
    cursor: pointer;
    border: solid 1px #e6e4e4;
    border-radius: 4px;

    &:hover {
      background: #fafafa;
    }

    .info {
      padding: 16px;

      .name {
        display: block;
        margin-bottom: 8px;
        text-transform: capitalize;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }

      .description {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        margin: 0;
        margin-bottom: 8px;
        overflow: hidden;
      }
    }
  }
}
</style>